import {
  defaultEventFilters,
  EventListRequestParams,
} from "../forms/filters/event";
import {
  BoolResponce,
  EventCardInfo,
  EventData,
  EventFullData,
  LibItem,
} from "../types";
import BackendConnect from "./connect";

export interface CommentInput {
  user_id?: number | null; // Optional for cases where the user_id is nullable
  tab_id: number;
  item_id: number;
  comment: string;
}

export interface CommentLikesCount {
  likes: number;
  dislikes: number;
}

export interface CommentUpdateInput {
  comment_id: number;
  user_id: number;
  comment: string;
}

export interface CommentOutput {
  id: number;
  user_id: number | null;
  tab_id: number;
  item_id: number;
  comment: string;
  date_created: Date;
  date_updated: Date | null;
  likes: number;
  dislikes: number;
}

export interface CommentLikeInput {
  comment_id: number;
  user_id: number;
  value_id: number; // 1 для лайка, 2 для дизлайка (соответствует id в таблице comment_like_types)
}

export const tabs: LibItem[] = [
  {
    id: 1,
    name: "events",
  },
  {
    id: 2,
    name: "tasks",
  },
  {
    id: 3,
    name: "clients",
  },
  {
    id: 4,
    name: "users",
  },
];

export class BackendCommentService extends BackendConnect {
  protected static instance: BackendCommentService;

  constructor(headers: Record<string, string>) {
    super(headers);
  }

  static getInstance(): BackendCommentService {
    if (!BackendCommentService.instance) {
      BackendCommentService.instance = new BackendCommentService({});
      const bearerToken = localStorage.getItem("bearerToken");
      if (bearerToken) {
        BackendCommentService.instance.setAccessToken(bearerToken);
      }
    }
    return BackendCommentService.instance;
  }

  public async addComment(data: {
    tab_id: number;
    item_id: number;
    comment: string;
  }): Promise<BoolResponce> {
    return this.post("/comments/new", data, "POST");
  }

  public async getComments(
    itemid: number,
    tabid: number
  ): Promise<{ comments: CommentOutput[] }> {
    return this.get(`/comments/list/${tabid}/${itemid}`);
  }

  public async likeComment(data: { comment_id: number; value_id: number }) {
    return this.post("/comments/like", data, "POST");
  }
}

export const commentBackend = BackendCommentService.getInstance();
